<template>
  <section class="table by6">
    <ul>
      <li><label>MOIS</label>
        <label><i style="color:var(--grey-dark)">⬤</i></label>
        <label><i style="color:var(--yellow)">⬤</i></label>
        <label><i style="color:var(--reserved)">⬤</i></label>
        <label><i style="color:var(--financed)">⬤</i></label>
        <label><i style="color:var(--acted)">⬤</i></label>
      </li>
    </ul>
    <ul>
      <li v-for="(per, p) in periods" :key="p">
        <span>{{ per.month }}</span>
        <span v-for="idx in 5" :key="idx" :class="{'small': showprice, 'verysmall':  idx === 1 && showprice}">
          <i v-if="showprice"> {{ per.price[idx-1] | euros }}</i><i v-else> {{ per.quantity[idx-1] }}</i>
        </span>
      </li>
      <li class="bold">
        <span>TOTAL</span>
        <span v-for="idx in 5" :key="idx" :class="{'small': showprice, 'verysmall':  idx === 1 && showprice}">
          <i v-if="showprice"> {{ totals.price[idx-1] | euros }}</i><i v-else> {{ totals.quantity[idx-1] }}</i>
        </span>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  name: 'StatisticsProgramPeriod',
  props: {
    numero: Number,
    customReservations: Array,
    showprice: Boolean,
    tva: Boolean
  },
  data () {
    return {
      price: false
    }
  },
  computed: {
    periods: function () {
      const monthNames = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre']
      const monthMap = {}
      const priceMap = {}
      const statusDateFields = ['datecancel', 'dateoption', 'datereserv', 'datefinanced', 'dateacted']

      // group lots by month from status-specific date fields
      this.customReservations.forEach(r => {
        const status = Number(r.status)
        const dateField = statusDateFields[status]
        var dateValue = r.lot[dateField]
        if (status === 4) dateValue = r.notary.signdate
        const date = new Date(dateValue)
        const month = monthNames[date.getMonth()]

        if (!monthMap[month]) {
          monthMap[month] = [0, 0, 0, 0, 0]
          priceMap[month] = [0, 0, 0, 0, 0]
        }
        monthMap[month][status]++
        if (this.tva) priceMap[month][status] += Number(r.lot.calculatedprice) || 0
        else priceMap[month][status] += Number(r.lot.actedprice) || 0
      })

      // sort by month order and return array with quantity and price
      return monthNames
        .filter(m => monthMap[m])
        .map(m => ({
          month: m,
          quantity: monthMap[m],
          price: priceMap[m]
        }))
    },
    totals: function () {
      const quantityTotals = [0, 0, 0, 0, 0]
      const priceTotals = [0, 0, 0, 0, 0]

      this.periods.forEach(per => {
        for (let i = 0; i < 5; i++) {
          quantityTotals[i] += per.quantity[i]
          priceTotals[i] += per.price[i]
        }
      })

      return {
        quantity: quantityTotals,
        price: priceTotals
      }
    }
  },
  methods: {
  }
}
</script>
